const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/old_components/components/LinkFrame.tsx';
import { css, cx } from '@emotion/css';
import { MessageDescriptor, useIntl } from 'react-intl';
import IconButton from '@mui/material/IconButton';
import { Icon } from '@mui/material';

import { FormElementProps } from '../defs';
import { ElementFrame } from './private/ElementFrame';
import { StaticText } from './StaticText';
import * as React from 'react';
import { Theme, useTheme } from '@mui/material/styles';

interface Props extends FormElementProps {
    text?: string | MessageDescriptor;
    iconName?: string;
    href?: string;
    onClick?: () => void;
    styleIcon?: React.CSSProperties;
}

const rootStyle = css`
    label: LinkFrame;
    display: flex;
    flex-direction: row;
`;

const titleStyle = css`
    flex: 1;
`;

const leftIconStyle = (theme: Theme) => css`
    display: flex;
    align-self: center;
    align-items: center;
    cursor: pointer;
    &:hover {
        // use Span because <icon /> will be rendered to span
        span,
        div {
            color: ${theme.palette.text.primary} !important;
        }
    }
`;

export const LinkFrame = (props: Props) => {
    const theme = useTheme();
    const hasIcon = !!props.href || !!props.iconName;

    if (!hasIcon && !props.text) {
        return null;
    }

    const onClick = () => {
        if (props.href) {
            window.open(props.href, '_blank');
        }

        if (props.onClick !== undefined) {
            props.onClick();
        }
    };

    const leftIcon = !hasIcon ? null : (
        <div className={leftIconStyle(theme)}>
            <div>
                <IconButton onClick={onClick} size="large">
                    <Icon className={props.iconName || 'icons8-document'} style={props.styleIcon} />
                </IconButton>
            </div>
            <StaticText className={titleStyle} component="button" text={props.text} onClick={onClick} isLink />
        </div>
    );

    return (
        <ElementFrame
            className={cx([rootStyle, props.className])}
            style={props.style}
            formEditClassName={props.formEditClassName}
            formEditStyle={props.formEditStyle}
            formViewClassName={props.formViewClassName}
            formViewStyle={props.formViewStyle}
        >
            {leftIcon}
        </ElementFrame>
    );
};
const iconStyle = css`
    font-size: 1rem;
    margin-right: 4px;
`;

export const LinkHrefTagFrame = (props: Props) => {
    const { formatMessage } = useIntl();
    const theme = useTheme();

    const hasIcon = !!props.href || !!props.iconName;

    if (!hasIcon && !props.text) {
        return null;
    }

    const text = props.text && (typeof props.text === 'string' ? props.text : formatMessage(props.text));

    const onClick = (evt: React.MouseEvent<any>) => {
        evt.stopPropagation();
        evt.preventDefault();
        if (props.href) {
            window.open(props.href, '_blank');
        }

        if (props.onClick !== undefined) {
            props.onClick();
        }
    };

    const leftIcon = !hasIcon ? null : (
        <div className={leftIconStyle(theme)} onClick={onClick}>
            <Icon className={cx(props.iconName || 'icons8-location', iconStyle)} style={props.styleIcon} />
            <div>{text}</div>
        </div>
    );

    return (
        <ElementFrame
            className={cx([rootStyle, props.className])}
            style={props.style}
            formEditClassName={props.formEditClassName}
            formEditStyle={props.formEditStyle}
            formViewClassName={props.formViewClassName}
            formViewStyle={props.formViewStyle}
        >
            {leftIcon}
        </ElementFrame>
    );
};
